import { useMutation } from '@tanstack/react-query';
import notificationsUserApi from 'api/notificationsUserApi';

const useDeleteNotificationByIdApi = () => {
    return useMutation((data) => notificationsUserApi.deleteNotificationById(data));
};

export default useDeleteNotificationByIdApi;
